import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import { useEffect, useRef } from "react";
import { TbCaretUpDownFilled } from "react-icons/tb";

export default function Experience(props) {
  const { RecuiterStore } = useStores();
  const minValueRef1 = useRef(null);
  const minValueRef2 = useRef(null);
  // Helper function to format salary value based on currency
  const formatSalary = (value, currency) => {
    if (!value) return "";
    let num = Number(value);

    if (currency === "₹ India") {
      if (num >= 10000000) return `${(num / 10000000).toFixed(1)} Cr`; // Crore
      if (num >= 100000) return `${(num / 100000).toFixed(1)} L`; // Lakh
      if (num >= 1000) return `${(num / 1000).toFixed(0)} K`; // Thousand
    } else if (currency === "$ USA") {
      if (num >= 1000000) return `${(num / 1000000).toFixed(0)} M`; // Million
      if (num >= 1000) return `${(num / 1000).toFixed(0)} K`; // Thousand
    } else if (currency === "€ Europe") {
      if (num >= 1000000) return `${(num / 1000000).toFixed(1)} M`; // Million
      if (num >= 1000) return `${(num / 1000).toFixed(0)} K`; // Thousand
    } else if (currency === "UGX Uganda") {
      if (num >= 1000000) return `${(num / 1000000).toFixed(1)} M`; // Million
      if (num >= 1000) return `${(num / 1000).toFixed(0)} K`; // Thousand
    }
    return num.toString(); // Less than 1000
  };

  useEffect(() => {
    if (props.label === "Salary") {
      if (
        RecuiterStore.jobPostDetails.basicJobDetails.jobType === "intership"
      ) {
        // Reset fields to allow 0 for internship
        props.action1({ target: { value: "" } });
        props.action2({ target: { value: "" } });
      } else {
        if (minValueRef1.current.value === "0") {
          minValueRef1.current.value = "1"; // Update the input value
        }
        if (minValueRef2.current.value === "0") {
          minValueRef2.current.value = "1"; // Update the input value
        }
        // Reset fields to force user to re-enter for job
        if (props.value1 === 0 || props.value2 === 0) {
          props.action1({ target: { value: "" } });
          props.action2({ target: { value: "" } });
        }
      }
    }
  }, [RecuiterStore.jobPostDetails.basicJobDetails.jobType]);

  const handleExperienceChange = (e, action) => {
    const rawValue = e.target.value;
    if (!/^[0-9]*$/.test(rawValue)) {
      e.target.value = rawValue.slice(0, -1);
      return;
    }

    const numericValue = Number(rawValue);
    if (numericValue > 10) {
      e.target.value = "10";
      action({ ...e, target: { ...e.target, value: 10 } });
      return;
    }

    action(e);
  };

  const handleSalaryChange = (e, action, jobType) => {
    let newValue = e.target.value;

    if (!/^[0-9]*$/.test(newValue)) {
      e.target.value = newValue.slice(0, -1);
    } else {
      newValue = Number(newValue);

      if (jobType === "job" && newValue === 0) {
        e.target.value = "";
        action({ target: { value: "" } });
        return;
      }

      action({ ...e, target: { ...e.target, value: newValue } });
    }
  };

  const handleChange = (e, action) => {
    if (
      props.label === "Required Experience (Years)" ||
      props.label === "Required experience"
    ) {
      handleExperienceChange(e, action);
    } else if (props.label === "Salary") {
      handleSalaryChange(
        e,
        action,
        RecuiterStore.jobPostDetails.basicJobDetails.jobType
      );
    }
  };

  const isFreeInternshipSalary =
    props.label === "Salary" &&
    RecuiterStore.jobPostDetails.basicJobDetails.jobType === "internship" &&
    Number(props.value1) === 0 &&
    Number(props.value2) === 0;

  return useObserver(() => (
    <>
      <div className="flex flex-col w-full gap-2 text-lg">
        <label className="font-sans text-base text-[#6D6B6B] ml-3">
          {props.label}
        </label>
        <div className="flex items-center justify-between w-full ">
          {/* Min Input */}
          <div className="flex flex-col w-40 ">
            <input
              type={props.label === "Salary" ? "number" : "text"}
              placeholder="Min"
              required
              max={props.max}
              ref={minValueRef1}
              {...(props.gen
                ? { value: props.value1 }
                : { defaultValue: props.value1 })}
              onChange={(e) => {
                let value = e.target.value;
                if (Number(value) > 9999999) {
                  e.target.value = "10000000";
                  // return;
                }
                handleChange(e, props.action1);
              }}
              className="border-[0.3px] px-4 rounded-lg w-full h-10 border-[#c9c9c9]"
            />
            <TbCaretUpDownFilled className="ml-auto -mt-7 mr-2 text-slate-400" />
            {!props.isResumeSorting ? (
              <div
                className={`mt-2 ml-2 ${
                  props.label === "Required experience (Years)" || !props.value1
                    ? "text-transparent"
                    : "text-gray-500"
                }`}
              >
                {isFreeInternshipSalary
                  ? "Free internship"
                  : props.value1
                  ? formatSalary(props.value1, props.currency)
                  : "hello"}
              </div>
            ) : (
              <div className="mt-5"></div>
            )}
          </div>
          <div className="flex flex-col">
            <div className="mb-3 mx-2">to</div>
            {/* <div className="text-transparent">h</div> */}
          </div>
          {/* Max Input */}
          <div className="flex flex-col w-40">
            <input
              type={props.label === "Salary" ? "number" : "text"}
              placeholder="Max"
              required
              max={props.max}
              ref={minValueRef2}
              {...(props.gen
                ? { value: props.value2 }
                : { defaultValue: props.value2 })}
              onChange={(e) => {
                let value = e.target.value;
                if (Number(value) > 9999999) {
                  e.target.value = "10000000";
                  // return;
                }
                handleChange(e, props.action2);
                // if (
                //   Number(e.target.value) < Number(minValueRef1.current.value)
                // ) {
                //   alert(
                //     "Max value should be greater than or equal to min value"
                //   );
                //   // e.target.value = minValueRef1.current.value;
                //   return;
                // }
              }}
              className="border-[0.3px] px-4 rounded-lg w-full h-10 border-[#c9c9c9]"
            />
            <TbCaretUpDownFilled className="ml-auto -mt-7 mr-2 text-slate-400" />

            {!props.isResumeSorting ? (
              <div
                className={`mt-2 ml-2 ${
                  props.label === "Required experience (Years)" || !props.value2
                    ? "text-transparent"
                    : "text-gray-500"
                }`}
              >
                {isFreeInternshipSalary
                  ? "Free internship"
                  : props.value2
                  ? formatSalary(props.value2, props.currency)
                  : "hello"}
              </div>
            ) : (
              <div className="mt-5"></div>
            )}
          </div>
          {!props.salary ? (
            <span> </span>
          ) : (
            !props.hide && <span> (in rupees)</span>
          )}
        </div>
      </div>
    </>
  ));
}
